import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * Position indicator of a guide: `dots` (one per step, current filled) or
 * `counter` ("3 of 15"). Both expose the position to assistive tech.
 */
@Component({
  selector: 'prep-tour-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'prep-tour-progress' },
  template: `
    <span *ngIf="variant === 'counter'; else dotsTpl" class="prep-tour-progress__counter" role="status" [attr.aria-label]="ariaLabel">{{ text }}</span>
    <ng-template #dotsTpl>
      <ol class="prep-tour-progress__dots" [attr.aria-label]="ariaLabel">
        <li *ngFor="let i of dots" class="prep-tour-progress__dot" [class.prep-tour-progress__dot--current]="i === index"
          [attr.aria-current]="i === index ? 'step' : null"></li>
      </ol>
    </ng-template>
  `,
  styles: [`
    .prep-tour-progress { display: inline-flex; align-items: center; }
    .prep-tour-progress__counter { border-radius: 999px; background: #f1f5f9; padding: 2px 8px; font-size: 11px; font-weight: 600; color: #475569; font-variant-numeric: tabular-nums; }
    .prep-tour-progress__dots { margin: 0; padding: 0; list-style: none; display: flex; gap: 5px; }
    .prep-tour-progress__dot { width: 7px; height: 7px; border-radius: 999px; background: #cbd5e1; }
    .prep-tour-progress__dot--current { background: #1976d2; }
  `],
})
export class PrepTourProgressComponent {
  /** 0-based current step. */
  @Input() index = 0;
  @Input() set count(v: number) { this.dots = Array.from({ length: Math.max(0, v) }, (_, i) => i); }
  @Input() variant: 'dots' | 'counter' = 'dots';
  /** Counter text ("3 of 15"); the host passes its translated form. */
  @Input() text = '';
  @Input() ariaLabel = '';
  dots: number[] = [];
}
